export const FETCH_BATCH_ORDER_BY_ID_SUCCESS = 'FETCH_BATCH_ORDER_BY_ID_SUCCESS';
export const FETCH_BATCH_ORDER_BY_ID_REQUEST = 'FETCH_BATCH_ORDER_BY_ID_REQUEST';
export const FETCH_BATCH_ORDER_BY_ID_FAILURE = 'FETCH_BATCH_ORDER_BY_ID_FAILURE';
export const FETCH_BATCH_ORDER_BY_ID_REST = 'FETCH_BATCH_ORDER_BY_ID_REST';
export const fetchBatchOrderByIdSuccess = (payload) => ({
    type: FETCH_BATCH_ORDER_BY_ID_SUCCESS,
    payload,
});
export const fetchBatchOrderByIdRequest = (payload) => ({
    type: FETCH_BATCH_ORDER_BY_ID_REQUEST,
    payload,
});
export const fetchBatchOrderByIdFailure = (payload) => ({
    type: FETCH_BATCH_ORDER_BY_ID_FAILURE,
    payload,
});
export const fetchBatchOrderByIdReset = () => ({
    type: FETCH_BATCH_ORDER_BY_ID_REST,
});
